import { render } from "./practiceHome.vue?vue&type=template&id=9bb51e94"
import script from "./practiceHome.vue?vue&type=script&lang=js"
export * from "./practiceHome.vue?vue&type=script&lang=js"

import "./practiceHome.vue?vue&type=style&index=0&id=9bb51e94&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__